"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Operations used by editTable() API
 */
var TableOperation;
(function (TableOperation) {
    /**
     * Insert a row above current row
     */
    TableOperation[TableOperation["InsertAbove"] = 0] = "InsertAbove";
    /**
     * Insert a row below current row
     */
    TableOperation[TableOperation["InsertBelow"] = 1] = "InsertBelow";
    /**
     * Insert a column on the left of current column
     */
    TableOperation[TableOperation["InsertLeft"] = 2] = "InsertLeft";
    /**
     * Insert a column on the right of current column
     */
    TableOperation[TableOperation["InsertRight"] = 3] = "InsertRight";
    /**
     * Delete the whole table
     */
    TableOperation[TableOperation["DeleteTable"] = 4] = "DeleteTable";
    /**
     * Delete current column
     */
    TableOperation[TableOperation["DeleteColumn"] = 5] = "DeleteColumn";
    /**
     * Delete current row
     */
    TableOperation[TableOperation["DeleteRow"] = 6] = "DeleteRow";
    /**
     * Merge current row with the row above
     */
    TableOperation[TableOperation["MergeAbove"] = 7] = "MergeAbove";
    /**
     * Merge current row with the row below
     */
    TableOperation[TableOperation["MergeBelow"] = 8] = "MergeBelow";
    /**
     * Merge current column with the column on the left
     */
    TableOperation[TableOperation["MergeLeft"] = 9] = "MergeLeft";
    /**
     * Merge current column with the column on the right
     */
    TableOperation[TableOperation["MergeRight"] = 10] = "MergeRight";
    /**
     * Split current table cell horizontally
     */
    TableOperation[TableOperation["SplitHorizontally"] = 11] = "SplitHorizontally";
    /**
     * Split current table cell vertically
     */
    TableOperation[TableOperation["SplitVertically"] = 12] = "SplitVertically";
    /**
     * Align current table at the center
     */
    TableOperation[TableOperation["AlignCenter"] = 13] = "AlignCenter";
    /**
     * Align current table at the left
     */
    TableOperation[TableOperation["AlignLeft"] = 14] = "AlignLeft";
    /**
     * Align current table at the right
     */
    TableOperation[TableOperation["AlignRight"] = 15] = "AlignRight";
    /**
     * Align current content table cell at the left
     */
    TableOperation[TableOperation["AlignCellLeft"] = 16] = "AlignCellLeft";
    /**
     * Align current content table cell at the center
     */
    TableOperation[TableOperation["AlignCellCenter"] = 17] = "AlignCellCenter";
    /**
     * Align current content table cell at the right
     */
    TableOperation[TableOperation["AlignCellRight"] = 18] = "AlignCellRight";
    /**
     * Align current content table cell at the top
     */
    TableOperation[TableOperation["AlignCellTop"] = 19] = "AlignCellTop";
    /**
     * Align current table cell at the middle
     */
    TableOperation[TableOperation["AlignCellMiddle"] = 20] = "AlignCellMiddle";
    /**
     * Align current table cell at the bottom
     */
    TableOperation[TableOperation["AlignCellBottom"] = 21] = "AlignCellBottom";
})(TableOperation = exports.TableOperation || (exports.TableOperation = {}));
//# sourceMappingURL=TableOperation.js.map